/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.score-button-list {
  @include mixins.use-available-space;

  .title {
    margin-bottom: variables.$margin-large;
  }

  .MuiList-root {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: variables.$gap-score-button-lists;

    &.reverse-true {
      flex-direction: column-reverse;
    }
    .MuiListItem-root {
      padding: 0;
    }

    .MuiButtonBase-root {
      border-radius: 4px;
      border: 1px solid variables.$color-corpuls-secondary-50;
      overflow: hidden;
      position: relative;
      isolation: isolate;
      height: variables.$score-button-height;
    }
  }

  .option {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    height: variables.$score-button-height;
    mix-blend-mode: multiply;

    .score {
      border-right: 1px solid variables.$color-corpuls-secondary-50;
      font-size: variables.$score-button-font-size;
      font-weight: 500;
      line-height: variables.$score-button-height;
      width: variables.$score-button-score-width;
      vertical-align: middle;
      text-align: center;
    }

    .label {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      font-size: variables.$score-button-font-size;
      font-weight: 500;
      vertical-align: middle;
      padding: 0 10px;
    }
  }

  .MuiButtonBase-root.Mui-selected {
    color: variables.$color-white;
    border: 1px solid transparent;

    .option {
      .score {
        background: variables.$color-darkorange;
      }

      .label {
        background: variables.$color-orange;
      }
    }
  }
}
